import React from 'react';
import { useData } from '../context/DataContext';
import SEO from '../components/SEO';

const Research = () => {
  const { research } = useData();
  return (
    <div className="animate-in fade-in slide-in-from-bottom-4 duration-700 pb-20">
      <SEO 
        title="Research & Publications" 
        description="Academic research, papers, and publications on generative art and AI by Leon Krykhtin."
        url="/research"
      />
      <h2 className="text-3xl font-bold tracking-tighter uppercase mb-12">Research</h2>
      
      <div className="space-y-12">
        {research.map((item, index) => (
          <div key={index} className="flex flex-col md:flex-row md:items-baseline border-b border-neutral-200 pb-8 last:border-0 group">
            <span className="text-sm font-mono text-neutral-400 w-24 mb-2 md:mb-0 shrink-0">{item.year}</span>
            <div className="flex-1">
              <h3 className="text-xl font-bold uppercase tracking-tight mb-1 group-hover:text-neutral-600 transition-colors">
                {item.title}
              </h3>
              <div className="flex flex-col text-neutral-500 text-sm mb-2">
                {item.authors && <span className="mb-1">{item.authors}</span>}
                <span className="italic">{item.publication}</span>
              </div>
              
              {item.link && (
                <a 
                    href={item.link} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-xs uppercase tracking-widest text-neutral-400 hover:text-black transition-colors border-b border-transparent hover:border-black inline-block mt-1"
                >
                    Read Paper
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Research;
